import React from 'react';

import PageWrapper from "../../components/page-wrapper/page-wrapper";

import {
    dinnerSponsors,
    donationLink,
    emailBody,
    emailSubject,
    missionCards,
    sponsorshipRegistrationLink,
    sponsorshipTiers,
    vedsEmail
} from "../../constants";
import SponsorshipCard from "../../components/sponsorship-card/sponsorship-card";
import {PlayerInformation} from "../../components/player-information/player-information";
import LocationMap from "../../components/location-map/location-map";
import MissionCard from "../../components/mission-card/mission-card";
import ContactCard from "../../components/contact-card/contact-card";
import HeadingUnderline from "../../components/heading-underline/heading-underline";
import SponsorBanner from "../../components/sponsor-banner/sponsor-banner";
import { useGetAnnualDisplay } from "../../hooks/useGetAnnualDisplay";

import logo from "../../img/logo.png";
import './home-page.css';

const HomePage = () => {
    const annualDisplay = useGetAnnualDisplay(true);
    return (
        <PageWrapper>
            {/* Hero Section */}
            <div className="container px-4 py-5 hero-container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-md-4 mx-auto">
                        <img className="hero-img" src={logo} alt="Bella's Mission Logo"/>
                    </div>
                    <div className="col-md-6 mx-auto">
                        <h2 className="text-red fw-bold">BELLA'S MISSION</h2>
                        <p className="my-4 lead">
                            VEDS is a life threatening connective tissue disorder causing extremely fragile arteries and
                            internal organs.
                            Proceeds are donated to VEDS research affiliates and for VEDS related medical expenses.
                        </p>
                        <p className="mb-4">
                            <strong>Bella's Mission Inc is a Texas 501(c)(3) Non-Profit Organization.</strong><br/>
                            All donations are tax deductible. Tax ID: 99-4650052
                        </p>
                        <div className="d-grid gap-2 d-md-flex justify-content-md-start mb-4">
                            <a className="btn btn-outline-primary btn-lg px-4 me-md-2" href={donationLink} target='_blank' rel="noreferrer">
                                Donate
                            </a>
                            <a className="btn btn-outline-primary btn-lg px-4" href="/about-us">
                                Learn More
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mission Section */}
            <div className="container-fluid bg-light section-padding">
                <div className="container">
                    <h2 className="text-center text-red section-title">OUR MISSION</h2>
                    <HeadingUnderline />
                    <p className="text-center mb-5 lead">
                        Bella's Mission is dedicated to improving the lives of people living with VEDS by raising awareness, funding critical research, and supporting individuals and families in need of financial assistance with the goal of one day finding a cure.
                    </p>
                    <div className="row">
                        {missionCards.map((card, idx) => (
                            <MissionCard
                                key={`mission-card-${idx}`}
                                title={card.title}
                                description={card.description}
                                icon={card.icon}
                            />
                        ))}
                    </div>
                </div>
            </div>

            {/* Sponsor Banner */}
            <SponsorBanner
                sponsors={dinnerSponsors}
                title={`THANK YOU TO OUR SPONSOR${dinnerSponsors.length > 1 ? 'S' : ''}`}
            />

            {/* Event Information Section */}
            <div className="bg-red text-white container-fluid section-padding">
                <div className="container">
                    <h2 className="text-center section-title">{annualDisplay} ANNUAL RESEARCH AND AWARENESS GOLF TOURNAMENT</h2>
                    <HeadingUnderline className="white" />
                    <div className="row">
                        <PlayerInformation/>
                        <LocationMap/>
                    </div>
                </div>
            </div>

            {/* Sponsorship Section */}
            <div className="container-fluid section-padding">
                <div className="container">
                    <h2 className="text-center text-red section-title">SPONSORSHIP OPPORTUNITIES</h2>
                    <HeadingUnderline />
                    <p className="text-center mb-5">
                        We offer several different types of sponsorship opportunity levels for individuals, teams, and businesses.
                    </p>
                    <div className="row sponsorship-scroll justify-content-center">
                        {sponsorshipTiers.map((tier, idx) => <SponsorshipCard key={`sponsorship-tier-${idx}`} tier={tier}/>)}
                    </div>
                    <div className="text-center mt-5">
                        <a className="btn btn-outline-primary btn-lg" href={sponsorshipRegistrationLink} target='_blank' rel="noreferrer">
                            Register Sponsorship
                        </a>
                    </div>
                </div>
            </div>

            {/* Contact Section */}
            <div className="bg-light container-fluid section-padding">
                <div className="container">
                    <h2 className="text-center text-red section-title">QUESTIONS?</h2>
                    <HeadingUnderline />
                    <div className="row">
                        <ContactCard title="PLAYER REGISTRATION">
                            <p>
                                For questions about <strong>registering for golf as a player, team, or sponsor,</strong> please reach
                                out to our Player Coordinators:
                            </p>
                            <p>Raul Marin - Phone: <a href='tel:915-256-8207'>915-256-8207</a></p>
                            <p>Jerry Sanchez - Phone: <a href='tel:915-240-1508'>915-240-1508</a></p>
                        </ContactCard>
                        <ContactCard title="DONATIONS & VOLUNTEERING">
                            <p>
                                For questions about <strong>donations and volunteering opportunities</strong> please reach out to our
                                Event Coordinator Frances Marin:
                            </p>
                            <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                                <a className='btn btn-outline-primary'
                                   href={`mailto:${vedsEmail}?subject=${emailSubject(true)}&body=${emailBody(true)}`}>Donations</a>
                                <a className='btn btn-outline-primary'
                                   href={`mailto:${vedsEmail}?subject=${emailSubject(false)}&body=${emailBody(false)}`}>Volunteering</a>
                            </div>
                        </ContactCard>
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
};

export default HomePage;